module.exports = __webpack_public_path__ + "img/pagos-active.1dccc7e1.svg";